export const HOTEL_HOVERED = 'HOTEL_HOVERED';
export const SHOW_MORE = 'SHOW_MORE';
export const PAGINATION_SUCCESS = 'PAGINATION_SUCCESS';
export const SET_CURRENT_VISIBLE_HOTELS = 'SET_CURRENT_VISIBLE_HOTELS';
